export default __webpack_public_path__ + "static/media/print-carroussel-3.dd4f5cad.png";